import { JWMCallout } from "@components/JWMCallout/JWMCallout";
import { Hero } from "@jmc/solid-design-system/src/components/atoms/Hero/Hero";
import { CMSColor } from "@jwm/types/CMSColor";
import { CMSHeroProps } from "@jwm/types/CMSHeroProps";

import { calloutColorMap } from "./CMSMapperDefinitions";
import { mapButtonProps } from "./mapButtonProps";

const mapCalloutColors = (cmsColor: CMSColor): HeroColor => {
    return calloutColorMap.get(cmsColor);
};

/**
 * transform a CMSHeroProps instance into props for a Callout component
 */
export const mapCalloutProps = (cmsProps: CMSHeroProps): React.ComponentProps<typeof Hero> => {
    const imageData = cmsProps?.background_image?.gatsbyImageData
        ? cmsProps?.background_image?.gatsbyImageData
        : cmsProps?.background_image?.url;
    return {
        id: cmsProps?.display_title,
        title: cmsProps?.display_title,
        image: imageData,
        imagePosition: cmsProps?.display_options?.image_focus?.toLowerCase() || "center-center",
        contentAlignment: cmsProps?.display_options?.align_content?.toLowerCase() === "right" ? "end" : "start",
        backgroundColor:
            cmsProps?.display_options?.background_color !== null
                ? mapCalloutColors(cmsProps?.display_options?.background_color as CMSColor)
                : "primary",
    };
};

/**
 * transform a CMSHeroProps instance into props for a JWMCallout component
 */
export const mapJWMCalloutProps = (cmsProps: CMSHeroProps): React.ComponentProps<typeof JWMCallout> => {
    const buttonProps = cmsProps?.call_to_action?.map((item) => mapButtonProps(item.button));
    const buttonPropsCarousel = cmsProps?.carousel?.slides?.map((slide) => mapButtonProps(slide.button));

    return {
        ...mapCalloutProps(cmsProps),
        description: cmsProps?.hero_body,
        footer: buttonProps?.length > 0 ? buttonProps : buttonPropsCarousel,
    };
};
